import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store/index";
//进度条
import NProgress from 'nprogress' ;
import 'nprogress/nprogress.css';
const routes: Array<RouteRecordRaw> = [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/login/login.vue"),
    },
    {
        path: "/downloadlist",
        name: "downloadlist",
        component: () => import("@/views/download/downloadlist.vue"),
    },
   
    {
        path: "/downloadcloudcare",
        name: "downloadcloudcare",
        component: () => import("@/views/download/downloadcloudcare.vue"),
    },
    {
        path: "/downloadfeicheng",
        name: "downloadfeicheng",
        component: () => import("@/views/download/downloadfeicheng.vue"),
    },
    {
        path: "/terms",
        name: "terms",
        component: () => import("@/views/download/terms.vue"),
    },
    
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to: any, from: any, next: any) => {
    NProgress.start();
   
    //未登陆
    if (!window.localStorage.getItem("token") && to.path != "/login"&&(to.path != "/downloadlist")&&(to.path != "/downloadcloudcare")&&(to.path != "/downloadfeicheng")&&(to.path != "/terms")) {
        console.log("not login");
       
        return next({ path: "/login" });
    };
    //已登陆
    if(window.localStorage.getItem("token")&&to.path == "/login") return next({ path: "/home/home" });
    //重新加载动态路由
    if (!store.state.permissionList&&to.path!='/login') {
        // router.removeRoute('router');
        return store.dispatch("FETCH_PERMISSION").then(() => {
            next({ ...to, replace: true });
        });
    } else {
        next();
    }
    
});
router.afterEach((to: any, from: any, next: any) => {
    NProgress.done();
    try {
        //设置标题
        if (to.meta.name) {
            document.title = to.meta.name;
        }
    } catch (err) {}
    let routerList = to.matched;
    //顶部面包屑
    store.commit("setCrumbList", routerList);
    //目前左边导航选中的active
    store.commit("SET_CURRENT_MENU", to.name);
});
/* 固定的路由 */
/*
    meta:{
        name:侧边栏名字,
        icon:侧边栏图标,
        hide:是否在侧边栏隐藏
    }
*/ 
export const DynamicRoutes = [
    {
        path: "",
        component:  () => import("@/components/nav/nav.vue"),
        name: "container",
        // redirect: 'home',
        meta: {
            // requiresAuth: true,
            name: "首页",
        },
        children: [
            {
                path: "home/index",
                component: () => import("@/views/home/index.vue"),
                name: "index",
                meta: {
                    name: "访客管理",
                    icon: "el-icon-document",
                },
                children:[
                    {
                        path: "/home",
                        component: () => import("@/views/home/home.vue"),
                        name: "home",
                        meta: {
                            name: "访客列表",
                            icon: "el-icon-position",
                        },
                    },
                    // {
                    //     path: "visitor",
                    //     component: () => import("@/views/home/visitor.vue"),
                    //     name: "visitor",
                    //     meta: {
                    //         name: "访客列表",
                    //         icon: "el-icon-position",
                    //     },
                    // },
                ]
            },
            {
                path: "productionList/index",
                component: () => import("@/views/admin/index.vue"),
                name: "productionList/index",
                meta: {
                    name: "服务器管理",
                    icon: "el-icon-document-copy",
                },
                children:[
                    {
                        path: "productionList",
                        component: () => import("@/views/admin/productionList.vue"),
                        name: "productionList",
                        meta: {
                            name: "服务器列表",
                            icon: "el-icon-position",
                        },
                    },
                    // {
                    //     path: "server",
                    //     component: () => import("@/views/admin/server.vue"),
                    //     name: "server",
                    //     meta: {
                    //         name: "服务器列表",
                    //         icon: "el-icon-position",
                    //     },
                    // },
                ]
            },
            // {
            //     path: "router",
            //     component: () => import("@/views/router/router.vue"),
            //     name: "router",
            //     meta: {
            //         name: "设备列表",
            //         icon: "el-icon-guide",
            //         hide:false
            //     },
            // },
            {
                path: "cproductList",
                component: () => import("@/views/admin/cproductList.vue"),
                name: "cproductList",
                meta: {
                    name: "个人中心",
                    icon: "el-icon-guide",
                    hide:true
                },
            },
            // {
            //     path: "map",
            //     component: () => import("@/views/map/index.vue"),
            //     name: "map",
            //     meta: {
            //         name: "地图",
            //         icon: "el-icon-map-location",
            //         hide:true,
            //     },
            //     children:[
            //         {
            //             path: "baidu",
            //             component: () => import("@/views/map/baidu.vue"),
            //             name: "baidu",
            //             meta: {
            //                 name: "百度地图",
            //                 icon: "el-icon-position",
            //             },
            //         },
            //         {
            //             path: "autoNavi",
            //             component: () => import("@/views/map/autoNavi.vue"),
            //             name: "autoNavi",
            //             hide:true,
            //             meta: {
            //                 name: "高德地图",
            //                 icon: "el-icon-position",
            //             },
            //         }
            //     ]
            // },
            {
                path: "download/index",
                component: () => import("@/views/download/index.vue"),
                name: "download/index",
                meta: {
                    name: "下载管理",
                    icon: "el-icon-document-copy",
                },
                children:[
                    {
                        path: "download1",
                        component: () => import("@/views/download/downloadlist.vue"),
                        name: "download1",
                        meta: {
                            name: "下载",
                            icon: "el-icon-position",
                        },
                    },
                    /*{
                        path: "downloadcloudcare",
                        component: () => import("@/views/download/downloadcloudcare.vue"),
                        name: "downloadcloudcare",
                        meta: {
                            title:"云关爱下载",
                            name: "云关爱下载",
                            icon: "el-icon-position",
                        },
                    },
                    {
                        path: "downloadfeicheng",
                        component: () => import("@/views/download/downloadfeicheng.vue"),
                        name: "downloadfeicheng",
                        meta: {
                            title:"非诚勿扰下载",
                            name: "非诚勿扰下载",
                            icon: "el-icon-position",
                        },
                    },*/
                ]
            },    
            
        ]
        
    }
];

export default router;
